import { httpClient } from '../http/httpClient'

export interface GetReferralResponse {
  referrals: 0
  registeredReferrals: 0
  validReferrals: 0
  bonusTotal: 0
  bonusPerReferral: 1000
}

export async function getReferral() {
  const { data } = await httpClient.get<GetReferralResponse>('user/me/referral')

  return data
}
